/*
 * =====================================================
 * AGING SUCKS - EMAIL CAPTURE MODAL FOR SHOPIFY
 * =====================================================
 * 
 * QUICK SETUP:
 * 
 * 1. In Shopify Admin: Online Store → Themes → "..." → Edit Code
 * 
 * 2. UPLOAD YOUR BACKGROUND IMAGE:
 *    - Click "Assets" folder → "Add a new asset"
 *    - Upload your background image (e.g., modal-bg.png)
 *    - Note the filename you used
 * 
 * 3. CREATE THE SCRIPT:
 *    - Click "Assets" → "Add a new asset" → Create blank file
 *    - Name it: modal-popup.js
 *    - Paste this entire file and Save
 * 
 * 4. ADD TO THEME:
 *    - Open "Layout" folder → click "theme.liquid"
 *    - Find </body> near the bottom
 *    - Add this line ABOVE </body>:
 *      <script src="{{ 'modal-popup.js' | asset_url }}" defer></script>
 * 
 * 5. Save and you're done!
 * 
 * =====================================================
 * CUSTOMIZE YOUR MODAL BELOW ↓
 * =====================================================
 */

const MODAL_CONFIG = {
  
  // ⭐ YOUR SUBSTACK (already configured for Aging Sucks)
  substack: 'agingsucks',
  
  // 📝 MODAL TEXT
  headline: 'Aging Sucks. Solutions & Science for Women.',
  subheadline: 'Women-specific longevity secrets & discounts',
  buttonText: 'Join the newsletter',
  successMessage: 'Welcome to the community! 🎉',
  
  // 🖼️ BACKGROUND IMAGE
  // Option 1: Use Shopify asset (upload image to Assets folder first)
  // Set to your image filename, e.g., 'modal-bg.png'
  backgroundImage: 'modal-bg.png',
  
  // Option 2: Use external URL (uncomment and use this instead)
  // backgroundImageUrl: 'https://your-domain.com/image.png',
  
  // Background settings
  backgroundSize: 'cover',      // 'cover', 'contain', or '100% 100%'
  backgroundPosition: 'center', // 'center', 'top', 'bottom'
  backgroundOverlay: 'rgba(255, 255, 255, 0.85)', // White overlay for readability
  
  // 📋 FORM FIELDS
  showFirstName: true,
  showLastName: true,
  firstNameRequired: true,
  lastNameRequired: false,
  
  // ⏱️ WHEN TO SHOW
  // Options: 'delay', 'scroll', 'exit', 'immediate'
  trigger: 'delay',
  delaySeconds: 999999999,
  scrollPercent: 50,
  
  // 🔄 HOW OFTEN TO SHOW
  // Options: 'session', 'day', 'once'
  frequency: 'session',
  
  // 📱 DEVICES
  showOnDesktop: false,
  showOnMobile: false,
  
  // 🚫 PAGES TO SKIP
  skipPages: ['/checkout', '/cart', '/account'],
  
  // 🎨 COLORS (dark text for light background)
  textColor: '#2d2d44',           // Dark purple-gray for headlines
  subtextColor: '#4a4a68',        // Slightly lighter for subheadline  
  buttonColor: '#8b7cb3',         // Soft purple matching the image
  buttonHoverColor: '#7a6ba3',    // Darker purple on hover
  inputBorderColor: '#c4b8db',    // Light purple border
  inputFocusBorderColor: '#8b7cb3', // Purple focus state
  overlayColor: 'rgba(139, 124, 179, 0.4)', // Purple-tinted overlay
  
  // 🔤 FONT
  font: 'Cormorant Garamond', // Elegant serif to match the aesthetic
  
  // ✨ ANIMATION: 'fade', 'slide', 'scale', 'none'
  animation: 'scale',
  
  // 📐 CORNER ROUNDNESS
  borderRadius: '20px',
};

/* =====================================================
 * DO NOT EDIT BELOW THIS LINE
 * ===================================================== */

(function(){
  'use strict';
  const C = MODAL_CONFIG;
  const K = 'mp_popup_v2';
  let modal, open = false;

  function init() {
    if (C.substack === 'YOUR_SUBSTACK_NAME') {
      console.warn('Modal Popup: Please set your Substack name in the config!');
      return;
    }
    if (!canShow()) return;
    loadFont();
    addStyles();
    createModal();
    setupTrigger();
  }

  function canShow() {
    const s = store();
    const path = location.pathname;
    
    if (C.skipPages.some(p => path.includes(p))) return false;
    if (C.frequency === 'once' && s.done) return false;
    if (C.frequency === 'session' && s.session) return false;
    if (C.frequency === 'day' && s.day === today()) return false;
    
    const mobile = window.innerWidth < 768;
    if (mobile && !C.showOnMobile) return false;
    if (!mobile && !C.showOnDesktop) return false;
    
    return true;
  }

  function today() {
    return new Date().toDateString();
  }

  function store(data) {
    const key = K;
    if (data) {
      try { sessionStorage.setItem(key + '_s', '1'); } catch(e) {}
      try { localStorage.setItem(key, JSON.stringify(data)); } catch(e) {}
    }
    try {
      const d = JSON.parse(localStorage.getItem(key) || '{}');
      d.session = sessionStorage.getItem(key + '_s') === '1';
      return d;
    } catch(e) { return {}; }
  }

  function loadFont() {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${C.font.replace(/ /g, '+')}:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&display=swap`;
    document.head.appendChild(link);
  }

  function getBgImage() {
    if (C.backgroundImageUrl) {
      return C.backgroundImageUrl;
    }
    if (C.backgroundImage && window.Shopify && window.Shopify.cdnHost) {
      // Try to construct Shopify CDN URL
      return `https://${window.Shopify.cdnHost}/s/files/1/assets/${C.backgroundImage}`;
    }
    // Fallback: assume it's in the assets folder (theme will resolve it)
    // This works when the script detects the asset URL pattern
    const scripts = document.querySelectorAll('script[src*="modal-popup"]');
    if (scripts.length > 0) {
      const src = scripts[0].src;
      const assetsBase = src.substring(0, src.lastIndexOf('/') + 1);
      return assetsBase + C.backgroundImage;
    }
    return null;
  }

  function addStyles() {
    const bgImage = getBgImage();
    const bgStyle = bgImage ? `url('${bgImage}')` : 'none';
    
    const css = `
      .mp-overlay {
        position: fixed;
        inset: 0;
        z-index: 999999;
        background: ${C.overlayColor};
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        opacity: 0;
        visibility: hidden;
        transition: all .35s ease;
        backdrop-filter: blur(4px);
      }
      .mp-overlay.mp-show {
        opacity: 1;
        visibility: visible;
      }
      .mp-box {
        position: relative;
        border-radius: ${C.borderRadius};
        max-width: 440px;
        width: 100%;
        box-shadow: 0 30px 60px -15px rgba(0,0,0,.3), 0 0 0 1px rgba(139,124,179,0.1);
        transform: ${C.animation==='scale'?'scale(.9)':C.animation==='slide'?'translateY(40px)':'none'};
        opacity: 0;
        transition: all .4s cubic-bezier(0.34, 1.56, 0.64, 1);
        overflow: hidden;
      }
      .mp-show .mp-box {
        transform: none;
        opacity: 1;
      }
      .mp-bg {
        position: absolute;
        inset: 0;
        background-image: ${bgStyle};
        background-size: ${C.backgroundSize};
        background-position: ${C.backgroundPosition};
        background-repeat: no-repeat;
        z-index: 0;
      }
      .mp-bg::after {
        content: '';
        position: absolute;
        inset: 0;
        background: ${C.backgroundOverlay};
        z-index: 1;
      }
      .mp-inner {
        position: relative;
        z-index: 2;
        padding: 48px 40px;
      }
      .mp-x {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border: none;
        background: rgba(255,255,255,0.7);
        backdrop-filter: blur(4px);
        cursor: pointer;
        opacity: .7;
        transition: all .2s;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        z-index: 10;
      }
      .mp-x:hover {
        opacity: 1;
        background: rgba(255,255,255,0.9);
        transform: scale(1.05);
      }
      .mp-x svg {
        width: 20px;
        height: 20px;
        stroke: ${C.textColor};
        stroke-width: 2.5;
      }
      .mp-h1 {
        font-size: 32px;
        font-weight: 600;
        color: ${C.textColor};
        margin: 0 0 8px;
        text-align: center;
        font-family: '${C.font}', Georgia, serif;
        letter-spacing: -0.02em;
        line-height: 1.1;
      }
      .mp-h2 {
        font-size: 18px;
        color: ${C.subtextColor};
        margin: 0 0 28px;
        text-align: center;
        line-height: 1.4;
        font-family: 'DM Sans', sans-serif;
        font-weight: 400;
      }
      .mp-form {
        display: flex;
        flex-direction: column;
        gap: 14px;
      }
      .mp-input {
        padding: 16px 18px;
        font-size: 15px;
        font-family: 'DM Sans', sans-serif;
        border: 2px solid ${C.inputBorderColor};
        border-radius: 12px;
        outline: none;
        transition: all .2s;
        background: rgba(255,255,255,0.9);
        color: ${C.textColor};
      }
      .mp-input:focus {
        border-color: ${C.inputFocusBorderColor};
        background: rgba(255,255,255,1);
        box-shadow: 0 0 0 4px rgba(139,124,179,0.15);
      }
      .mp-input::placeholder {
        color: #8a8a9a;
      }
      .mp-btn {
        padding: 18px;
        font-size: 16px;
        font-weight: 600;
        font-family: 'DM Sans', sans-serif;
        background: ${C.buttonColor};
        color: #fff;
        border: none;
        border-radius: 12px;
        cursor: pointer;
        transition: all .25s;
        text-transform: uppercase;
        letter-spacing: 0.08em;
        margin-top: 4px;
      }
      .mp-btn:hover:not(:disabled) {
        background: ${C.buttonHoverColor};
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(139,124,179,0.35);
      }
      .mp-btn:disabled {
        opacity: .7;
        cursor: wait;
      }
      .mp-note {
        font-size: 12px;
        color: ${C.subtextColor};
        margin: 16px 0 0;
        text-align: center;
        font-family: 'DM Sans', sans-serif;
      }
      .mp-ok {
        text-align: center;
        padding: 24px 0;
      }
      .mp-ok-icon {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background: ${C.buttonColor};
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
        box-shadow: 0 8px 20px rgba(139,124,179,0.3);
      }
      .mp-ok-icon svg {
        width: 35px;
        height: 35px;
        stroke: #fff;
        stroke-width: 3;
      }
      .mp-ok-msg {
        font-size: 24px;
        font-weight: 600;
        color: ${C.textColor};
        margin: 0;
        font-family: '${C.font}', Georgia, serif;
      }
      .mp-err {
        color: #c53030;
        font-size: 13px;
        text-align: center;
        margin-top: 10px;
        font-family: 'DM Sans', sans-serif;
        background: rgba(197,48,48,0.1);
        padding: 8px 12px;
        border-radius: 8px;
      }
      @media(max-width:480px) {
        .mp-inner {
          padding: 40px 24px;
        }
        .mp-h1 {
          font-size: 26px;
        }
        .mp-h2 {
          font-size: 16px;
        }
      }
    `;
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  function createModal() {
    modal = document.createElement('div');
    modal.className = 'mp-overlay';
    modal.innerHTML = `
      <div class="mp-box">
        <div class="mp-bg"></div>
        <button class="mp-x" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        <div class="mp-inner">
          <div class="mp-content">
            <h2 class="mp-h1">${esc(C.headline)}</h2>
            ${C.subheadline ? `<p class="mp-h2">${esc(C.subheadline)}</p>` : ''}
            <form class="mp-form">
              ${C.showFirstName ? `<input class="mp-input" name="fn" placeholder="First Name" ${C.firstNameRequired ? 'required' : ''}>` : ''}
              ${C.showLastName ? `<input class="mp-input" name="ln" placeholder="Last Name" ${C.lastNameRequired ? 'required' : ''}>` : ''}
              <input class="mp-input" name="email" type="email" placeholder="Email Address" required>
              <button class="mp-btn" type="submit">${esc(C.buttonText)}</button>
            </form>
            <p class="mp-note">We respect your privacy. Unsubscribe anytime.</p>
          </div>
          <div class="mp-ok" style="display:none">
            <div class="mp-ok-icon">
              <svg viewBox="0 0 24 24" fill="none"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <p class="mp-ok-msg">${esc(C.successMessage)}</p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    
    modal.querySelector('.mp-x').onclick = hide;
    modal.onclick = e => { if (e.target === modal) hide(); };
    modal.querySelector('form').onsubmit = submit;
    document.onkeydown = e => { if (e.key === 'Escape' && open) hide(); };
  }

  function setupTrigger() {
    switch(C.trigger) {
      case 'immediate': show(); break;
      case 'delay': setTimeout(show, C.delaySeconds * 1000); break;
      case 'scroll':
        let done = false;
        window.addEventListener('scroll', function check() {
          if (done) return;
          const pct = (scrollY / (document.body.scrollHeight - innerHeight)) * 100;
          if (pct >= C.scrollPercent) { done = true; show(); }
        });
        break;
      case 'exit':
        document.addEventListener('mouseout', function check(e) {
          if (e.clientY < 10 && !open) { show(); document.removeEventListener('mouseout', check); }
        });
        break;
    }
  }

  function show() {
    if (!modal || open) return;
    open = true;
    modal.classList.add('mp-show');
    document.body.style.overflow = 'hidden';
    store({ ...store(), session: true, day: today() });
  }

  function hide() {
    if (!open) return;
    open = false;
    modal.classList.remove('mp-show');
    document.body.style.overflow = '';
  }

  async function submit(e) {
    e.preventDefault();
    const form = e.target;
    const btn = form.querySelector('.mp-btn');
    const fd = new FormData(form);
    
    btn.disabled = true;
    btn.textContent = 'Subscribing...';
    form.querySelector('.mp-err')?.remove();

    try {
      const url = `https://${C.substack}.substack.com`;
      const res = await fetch(`${url}/api/v1/free`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: fd.get('email'),
          first_url: url,
          first_referrer: '',
          current_url: url,
          current_referrer: '',
          referral_code: '',
          source: 'embed'
        })
      });
      
      if (res.ok) {
        modal.querySelector('.mp-content').style.display = 'none';
        modal.querySelector('.mp-ok').style.display = 'block';
        store({ ...store(), done: true });
        setTimeout(hide, 3000);
      } else {
        throw new Error('Please try again');
      }
    } catch(err) {
      const errEl = document.createElement('p');
      errEl.className = 'mp-err';
      errEl.textContent = err.message || 'Something went wrong';
      form.appendChild(errEl);
      btn.disabled = false;
      btn.textContent = C.buttonText;
    }
  }

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
